const urlWithEventHubParams = (url, options) => `${url}?eventHubName=${options.eventHubName}&connectionString=${options.connectionString}&consumerGroup=${options.consumerGroup}`;
export default urlWithEventHubParams;
